<template>
  <div></div>
</template>

<script>
export default {
  name: "ed-form-mixin",
  components: {},
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: [Boolean,Number],
      required: false,
      default: false,
    },
    disabledItem: {
      type: Function,
      required: false,
      default: function(){},
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: [String],
      required: false,
      default: null,
    },
    color: {
      type: [String],
      required: false,
      default: null,
    },
    width: {
      type: [Number, String],
      required: false,
      default: "auto",
    },
    info: {
      type: [Number, String],
      required: false,
      default: null,
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: null,
    },
    maxLenght: {
      type: [Number, String],
      required: false,
      default: null,
    },
    label: {
      type: [Number, String, Boolean],
      required: false,
      default: '',
    },
    title: {
      type: [Number, String],
      required: false,
      default: null,
    },
    value: {
      type: [Number, String, Boolean, Array, Object, Date, File, Event],
      required: false,
      default: null,
    },
    valueKey:{
      type: [String],
      required: false,
      default: 'id',
    },
    color: {
      type: [String],
      required: false,
      default: "primary",
    },
    iconRight: {
      type: String,
      required: false,
      default: null,
    },
    iconLeft: {
      type: String,
      required: false,
      default: null,
    },
    classe: {
      type: [String],
      required: false,
      default: null,
    },
    filterable: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    remote: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    rules: {
      type: [String],
      required: false,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      intUniqId: Date.now(),
      validateClass: "",
      labelHtml: "",
      errors:{}
    };
  },
  methods: {
    setEvent(event,data) {
      this.$emit(event,data);
      this.$root.$session.event = {
        event:event,
        data:data
      }
    },

    focus() {
      if (this.$refs.field) {
        this.$refs.field.focus();
      }
    },
    validate($event) {
      // let valid = true;

      // this.errors = {}
      // this.getRules.forEach((rules) => {
      //   let retorno = rules(this.value);

      //   if(retorno !== true){
      //     this.errors[this.name] = retorno
      //     valid = false;
      //   }
      // });
      
      // if(valid){
      //   this.$emit('blur', $event)
      // }
      // else{
      //   this.$emit('input', null)
      // }
    },
  },
  mounted() {},
  computed: {
    getError() {

      if(this.errors[this.name]){
        return this.errors[this.name];
      }
      return false;
    },

    getErrorContents() {
      let response = this.$root.$request.getResponse;

      if (response && response.status == 400) {
        for (var field in response.data.error.options) {
          if (field == this.name) {
            return response.data.error.options[field];
          }
        }
      }

      return [];
    },

    getRules() {
      let rules = [];
      let arrayAux = [];

      if (this.rules) {
        arrayAux = this.rules.split("|").concat(arrayAux);

        arrayAux.forEach((rule) => {
          if (rule.indexOf("required") != -1) {
            rules.push((v) => !!v || "Campo obrigatório");
          }

          if (rule.indexOf("email") != -1) {
            rules.push(
              (v) => (v && this.$utilidade.isEmail(v)) || "Email inválido"
            );
          }

          if (rule.indexOf("numeric") != -1) {
            rules.push(
              (v) =>
                (v && this.$utilidade.isNumeric(v)) || "Digite um número válido"
            );
          }

          if (rule.indexOf("cpf") != -1) {
            rules.push(
              (v) => (v && this.$utilidade.isCpf(v)) || "Digite um CPF válido"
            );
          }

          if (rule.indexOf("date") != -1) {
            rules.push(
              (v) =>
                (v && this.$utilidade.isDate(v)) ||
                "Digite uma data válida no formato dd/mm/aaaa"
            );
          }

          if (rule.indexOf("cnpj") != -1) {
            rules.push(
              (v) => (v && this.$utilidade.isCnpj(v)) || "Digite um CNPJ válido"
            );
          }

          if (rule.indexOf("min:") != -1) {
            let min = parseInt(rule.split(":")[1]);

            rules.push(
              (v) =>
                (v && v.length >= min) ||
                "Campo deve conter ao menos " + min + " caracteres"
            );
          }

          if (rule.indexOf("max:") != -1) {
            let max = parseInt(rule.split(":")[1]);

            rules.push(
              (v) =>
                (v && v.length <= max) ||
                "Campo deve conter até " + max + " caracteres"
            );
          }
        });
      }

      return rules;
    },
  },
  watch: {
    name() {},
    label() {},
    value() {},
    multiple() {},
    clearable() {},
    required() {},
    loading() {},
    disabled() {},
    readonly() {},
    valueKey(){},
    maxLenght(){},
  },
};
</script>



// WEBPACK FOOTER //
// formControl.vue?6af5b764